module.exports = __webpack_public_path__ + "img/ogp_mrclick_big.dc1c74b5.jpg";